import { connect, ConnectedProps } from 'react-redux';
import { ScreenWrapper } from '../../components/atoms/ScreenWrapper/ScreenWrapper';
import { useCredentialsPoller as useCredentialsPollerImport } from '../../components/hooks/useCredentialsPoller/useCredentialsPoller';
import { CredentialsEntity } from '../../models/credentials';
import { ProviderEntity } from '../../models/provider';
import { stopPollingCredentials as stopPollingCredentialsImport } from '../../connectivity/services/credentials';
import { setCredentials as setCredentialsConnect } from '../../stores/credentials-store';
import {
  SupplementalInformationMachineProps,
  SupplementalInformationMachineView as SupplementalInformationMachineViewImport,
} from '../../connectivity/screens/templates/SupplementalInformationMachineView';
import { usePageViewEvents } from '../../core/Analytics/usePageViewEvents';
import { PageView } from '../../models/analytics';

export type AwaitingSupplementalInformationOwnProps = {
  provider: ProviderEntity;
  credentials: CredentialsEntity;
  stopPollingCredentials?: () => void;
  useCredentialsPoller?: typeof useCredentialsPollerImport;
  SupplementalInformationMachineView?: React.ComponentType<SupplementalInformationMachineProps>;
};

export type AwaitingSupplementalInformationProps = AwaitingSupplementalInformationOwnProps &
  PropsFromRedux;

export const AwaitingSupplementalInformationPresenter: React.FC<
  AwaitingSupplementalInformationProps
> = ({
  provider,
  credentials,
  setCredentials,
  stopPollingCredentials = stopPollingCredentialsImport,
  useCredentialsPoller = useCredentialsPollerImport,
  SupplementalInformationMachineView = SupplementalInformationMachineViewImport,
}) => {
  const { signCredentials } = useCredentialsPoller();

  usePageViewEvents({ pageView: PageView.SUPPLEMENTAL_INFORMATION_SCREEN });

  stopPollingCredentials();

  const onDone = (c: CredentialsEntity) => {
    setCredentials(c);
    signCredentials(c.id);
  };

  return (
    <ScreenWrapper data-testid="supplemental-information-machine-view">
      <SupplementalInformationMachineView
        credentials={credentials}
        provider={provider}
        onDone={onDone}
        onError={setCredentials}
      />
    </ScreenWrapper>
  );
};

const mapDispatchToProps = {
  setCredentials: setCredentialsConnect,
};

const connector = connect(null, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export const AwaitingSupplementalInformation = connector(AwaitingSupplementalInformationPresenter);
